import { render, staticRenderFns } from "./AfterVerification.vue?vue&type=template&id=2f50e7fe&scoped=true&"
import script from "./AfterVerification.vue?vue&type=script&lang=js&"
export * from "./AfterVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f50e7fe",
  null
  
)

export default component.exports